import React, { useState, useContext, useEffect } from "react";
import { Context } from "./../../../contexts/Store";
import { baseConfig } from "./../../../axiosConfig";
import Loader from "../../includes/loader/Loader";
import styled from "styled-components";
import EmptyPage from "../../includes/emptyPages/EmptyPage";
import emptyPic from "../../../assets/icons/live-class-empty-icon.svg";
import { toast, Toaster } from "sonner";

const Announcements = () => {
    const [isLoading, setLoading] = useState(true);
    const { state } = useContext(Context);

    const [announcements, setAnnouncements] = useState([]);
    const [expandedAnnouncements, setExpandedAnnouncements] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    const toggleReadMore = (index) => {
        setExpandedAnnouncements((prevExpanded) => ({
            ...prevExpanded,
            [index]: !prevExpanded[index],
        }));
    };

    const getAnnouncements = async (page = 1) => {
        setLoading(true);
        let accessToken = state.user_details.access_token;

        try {
            const response = await baseConfig.get(
                `/students/student-announcements/?page=${page}`,
                {
                    headers: {
                        Authorization: "Bearer " + accessToken,
                    },
                }
            );

            const { StatusCode, data } = response.data;
            if (StatusCode === 6000) {
                setAnnouncements(data?.announcements);
                setTotalPages(data?.paginator?.num_pages || 1);
                setTotalItems(data?.paginator?.count || 0);
            } else {
                toast.error("Failed to fetch announcements");
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAnnouncements(currentPage);
    }, [currentPage]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const htmlcontent = (content) => {
        return `<style>
                    p {
                        margin-top: 10px;
                        color: black !important;
                    }
                </style>
        ${content}`;
    };

    return (
        <MainContainer>
            <Toaster richColors closeButton position="top-right" />
            {!isLoading ? (
                <>
                    {announcements.length > 0 ? (
                        <>
                            <SectionTitleContainer>
                                <SectionTitle>Announcements</SectionTitle>
                            </SectionTitleContainer>
                            <AssignmentsListContainer>
                                <AnnouncementsCards>
                                    {announcements.map(
                                        (announcement, index) => (
                                            <Card key={index}>
                                                <CardTop>
                                                    <CardHeading>
                                                        {announcement.title}
                                                    </CardHeading>
                                                    {announcement.published_date ? (
                                                        <DateContainer>
                                                            <Date>
                                                                {
                                                                    announcement.published_date
                                                                }
                                                            </Date>
                                                            {/* <StatusBadge isUpcoming={new Date(announcement.published_date) > new Date()}>
                                                                {new Date(announcement.published_date) > new Date() ? "Upcoming" : "Past"}
                                                            </StatusBadge> */}
                                                        </DateContainer>
                                                    ) : null}
                                                </CardTop>
                                                <CardContent>
                                                    <div
                                                        className="htmlTag"
                                                        style={{
                                                            color: "black",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: !expandedAnnouncements[
                                                                index
                                                            ]
                                                                ? htmlcontent(
                                                                      announcement.description
                                                                  ).slice(
                                                                      0,
                                                                      300
                                                                  )
                                                                : htmlcontent(
                                                                      announcement.description
                                                                  ),
                                                        }}
                                                    />
                                                    {announcement.description
                                                        .length > 300 && (
                                                        <ReadMore
                                                            onClick={() =>
                                                                toggleReadMore(
                                                                    index
                                                                )
                                                            }
                                                        >
                                                            {expandedAnnouncements[
                                                                index
                                                            ]
                                                                ? " Read less"
                                                                : " Read more"}
                                                        </ReadMore>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        )
                                    )}
                                </AnnouncementsCards>
                            </AssignmentsListContainer>
                            <PaginationContainer>
                                <PaginationControls>
                                    <PaginationButton
                                        onClick={() =>
                                            handlePageChange(currentPage - 1)
                                        }
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </PaginationButton>
                                    <PageNumbers>
                                        {[...Array(totalPages)].map(
                                            (_, index) => (
                                                <PageNumber
                                                    key={index + 1}
                                                    active={
                                                        currentPage ===
                                                        index + 1
                                                    }
                                                    onClick={() =>
                                                        handlePageChange(
                                                            index + 1
                                                        )
                                                    }
                                                >
                                                    {index + 1}
                                                </PageNumber>
                                            )
                                        )}
                                    </PageNumbers>
                                    <PaginationButton
                                        onClick={() =>
                                            handlePageChange(currentPage + 1)
                                        }
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </PaginationButton>
                                </PaginationControls>
                            </PaginationContainer>
                        </>
                    ) : (
                        <EmptyContainer>
                            <EmptyPage
                                img={emptyPic}
                                message="Sorry, nothing here"
                            />
                        </EmptyContainer>
                    )}
                </>
            ) : (
                <Loader />
            )}
        </MainContainer>
    );
};

const MainContainer = styled.div`
    background: #ffffff;
    padding: 20px 15px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    border-radius: 10px;
    height: calc(100vh - 110px);
    display: flex;
    flex-direction: column;
`;

const SectionTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-top: 20px;
    padding-right: 5px;
    flex-shrink: 0;
`;

const SectionTitle = styled.h3`
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 10px;
`;

const AssignmentsListContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 10px 8px 10px 5px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-right: 8px;
    &::-webkit-scrollbar {
        width: 2px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #d6dee1;
        border-radius: 20px;
    }
`;

const EmptyContainer = styled.div`
    height: calc(100vh - 145px);
    overflow-y: scroll;
`;

const AnnouncementsCards = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
`;

const Card = styled.li`
    border: 1px solid #e5e5e5;
    border-radius: 20px;
    padding: 24px;
    width: 100%; // Updated to take full width
`;

const CardTop = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    color: #010101;
`;

const CardHeading = styled.h5`
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

const DateContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px; // Adds spacing between the badges
`;

const Date = styled.div`
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
    text-transform: capitalize;
    background-color: #5c3795;
    color: #ffffff;
    padding: 4px 12px;
    border-radius: 12px;
    display: inline-block;
    text-align: center;
`;

const StatusBadge = styled.div`
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
    text-transform: capitalize;
    background-color: ${(props) => (props.isUpcoming ? "#28a745" : "#dc3545")};
    color: #ffffff;
    padding: 4px 12px;
    border-radius: 12px;
    display: inline-block;
    text-align: center;
`;

const CardContent = styled.p`
    color: #9d9d9d;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;

const ReadMore = styled.span`
    color: #4a96ef;
    font-size: 15px;
    cursor: pointer;
`;

const htmlTags = styled.p`
    color: black;
`;

const PaginationContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    padding-top: 10px;
    padding-bottom: 5px;
    flex-shrink: 0;
`;

const PaginationInfo = styled.div`
    font-size: 14px;
    color: #666;
`;

const PaginationControls = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const PaginationButton = styled.button`
    padding: 8px 16px;
    border: 1px solid #5c3795;
    background-color: ${(props) => (props.disabled ? "#f5f5f5" : "#fff")};
    color: ${(props) => (props.disabled ? "#999" : "#5c3795")};
    border-radius: 4px;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    font-size: 14px;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        background-color: #5c3795;
        color: #fff;
    }
`;

const PageNumbers = styled.div`
    display: flex;
    gap: 5px;
`;

const PageNumber = styled.button`
    width: 32px;
    height: 32px;
    border: 1px solid ${(props) => (props.active ? "#5c3795" : "#ddd")};
    background-color: ${(props) => (props.active ? "#5c3795" : "#fff")};
    color: ${(props) => (props.active ? "#fff" : "#333")};
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;

    &:hover {
        background-color: ${(props) => (props.active ? "#5c3795" : "#f5f5f5")};
    }
`;

export default Announcements;
